export default "__VITE_ASSET__iDZs2S4M__"